import { Inject, Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import {
  META_CONFIG,
  MetaConfig,
  MetaLoader,
  MetaSettings,
  PageTitlePositioning,
} from './meta.config';

@Injectable({ providedIn: 'root' })
export class MetaGuard  {
  private readonly settings: MetaConfig;

  constructor(
    private title: Title,
    private meta: Meta,
    @Optional() @Inject(META_CONFIG) config: MetaConfig | null,
    @Optional() loader: MetaLoader | null
  ) {
    this.settings = (loader && loader.getSettings()) || config || {};
  }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    this.apply(route);
    return true;
  }

  canActivateChild(route: ActivatedRouteSnapshot): boolean {
    this.apply(route);
    return true;
  }

  private apply(route: ActivatedRouteSnapshot): void {
    let current = route;
    while (current.firstChild) {
      current = current.firstChild;
    }

    const defaults: MetaSettings = this.settings.defaults || {};
    const routeMeta: MetaSettings = (current.data && current.data['meta']) || {};
    const merged: MetaSettings = { ...defaults, ...routeMeta };

    const pageTitle = (merged.title as string) || '';
    const appName = this.settings.applicationName || '';
    const separator = this.settings.pageTitleSeparator || ' - ';
    const override = !!merged.override;

    let fullTitle = pageTitle;
    if (!override && appName) {
      if (
        this.settings.pageTitlePositioning ===
        PageTitlePositioning.AppendPageTitle
      ) {
        fullTitle = pageTitle ? `${appName}${separator}${pageTitle}` : appName;
      } else {
        fullTitle = pageTitle ? `${pageTitle}${separator}${appName}` : appName;
      }
    }
    if (fullTitle) {
      this.title.setTitle(fullTitle);
    }

    Object.keys(merged).forEach((key) => {
      if (key === 'title' || key === 'override') {
        return;
      }
      const value = merged[key];
      if (typeof value !== 'string' || !value) {
        return;
      }
      if (key === 'description') {
        this.meta.updateTag({ name: 'description', content: value });
        return;
      }
      if (key.startsWith('og:')) {
        this.meta.updateTag({ property: key, content: value });
        return;
      }
      this.meta.updateTag({ name: key, content: value });
    });
  }
}
